<!-- Image -->
<p-image [src]="src"
         [alt]="alt"
         styleClass="{{ inputClass }}"
         width="{{ width }}"
         height="{{ height }}">
</p-image>
